import { cn } from "@/lib/utils";

/** Même anneau conique bleu / jaune / rouge que le bouton « retour en haut » (BackToTop). */
const RING_STYLE = {
  background: "conic-gradient(from 90deg, #190276 0% 33%, #F2B531 33% 66%, #f7040a 66% 100%)",
};

export function EppTricolorRingButton({ className, buttonClassName, children, ...props }) {
  return (
    <div className={cn("rounded-full p-[3px] shadow-lg", className)} style={RING_STYLE}>
      <button
        type="button"
        className={cn(
          "flex h-12 w-12 items-center justify-center rounded-full bg-[#190276] text-white transition-colors hover:bg-[#130160] focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40",
          buttonClassName,
        )}
        {...props}
      >
        {children}
      </button>
    </div>
  );
}
